const HUBSPOT_SCRIPT_ID = 'hubspot-forms-v2-script';
const HUBSPOT_SCRIPT_SRC = 'https://js.hsforms.net/forms/embed/v2.js';

let hubspotScriptPromise: Promise<void> | null = null;

function loadHubspotScript() {
  if (window.hbspt?.forms) {
    return Promise.resolve();
  }

  if (hubspotScriptPromise) {
    return hubspotScriptPromise;
  }

  hubspotScriptPromise = new Promise<void>((resolve, reject) => {
    const existingScript = document.getElementById(
      HUBSPOT_SCRIPT_ID,
    ) as HTMLScriptElement | null;

    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(), { once: true });
      existingScript.addEventListener(
        'error',
        () => reject(new Error('Failed to load HubSpot form script.')),
        { once: true },
      );
      return;
    }

    const script = document.createElement('script');
    script.id = HUBSPOT_SCRIPT_ID;
    script.async = true;
    script.charset = 'utf-8';
    script.src = HUBSPOT_SCRIPT_SRC;
    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error('Failed to load HubSpot form script.'));

    document.body.appendChild(script);
  });

  return hubspotScriptPromise;
}

export async function createHubSpotForm(options: HubSpotFormCreateParameters) {
  await loadHubspotScript();

  if (!window.hbspt?.forms) {
    throw new Error('HubSpot form SDK is unavailable.');
  }

  window.hbspt.forms.create(options);
}
